import { useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { parse as parseParams } from 'hub-http/helpers/params';
import * as CategorySlug from 'marketplace-ui-apps-core/common/constants/urlSlugs/CategorySlug';
import * as SuperCategorySlug from 'marketplace-ui-apps-core/common/constants/urlSlugs/SuperCategorySlug';
import useDetails from 'marketplace-ui-apps-core/details/hooks/useDetails';
import useDetailsPreview from 'marketplace-ui-apps-core/details/hooks/useDetailsPreview';
import ListingView from 'marketplace-ui-apps-core/details/records/ListingView';
import { getCategorySuperCategory } from 'marketplace-ui-apps-core/common/utils/groupTags';
import { useAppContext } from '../../context/AppContext';
// @ts-expect-error untyped dependency
import { replace } from '../history';
// @ts-expect-error untyped dependency
import { useParsedPathParams } from './useParsedPathParams';
export function useListingView() {
  const {
    path
  } = useRouteMatch();
  const appContext = useAppContext();
  const {
    search,
    hash
  } = useLocation();
  const params = useParams();
  const {
    published,
    language
  } = parseParams(search.slice(1));
  const isPreview = published === 'false' || path === '/_preview/:slug' || appContext === 'admin-preview';
  const {
    category: activeCategory,
    slug
  } = useParsedPathParams(params);
  const validateDetailsUrl = category => {
    const isShortlink = path.includes('/_detail/:slug');
    const isReviewLink = path.includes('/:slug/write-review');
    if (isShortlink) {
      const superCategory = category ? getCategorySuperCategory(category) : null;
      if (!(category && superCategory)) {
        throw new Error('Super category & category required to redirect');
      }
      const superCategoryFacet = SuperCategorySlug[superCategory];
      const categoryFacet = CategorySlug[category];
      replace(`/${superCategoryFacet}/${categoryFacet}/${slug}${isReviewLink ? '/write-review' : ''}${search}${hash}`);
    }
    if (!isPreview && activeCategory && category !== activeCategory) {
      throw new Error('Invalid category slug');
    }
  };
  const onDetailsCompleted = response => {
    const details = response.appDetails;
    validateDetailsUrl(details.category);
  };
  const {
    detailsData,
    detailsLoading,
    detailsError
  } = useDetails({
    appContext,
    slug,
    skip: isPreview,
    onDetailsCompleted
  });
  const {
    detailsPreviewData,
    detailsPreviewLoading,
    detailsPreviewError
  } = useDetailsPreview({
    appContext,
    slug,
    skip: !isPreview,
    language,
    onDetailsCompleted
  });
  return {
    listingView: new ListingView(isPreview ? Object.assign({}, detailsPreviewData === null || detailsPreviewData === void 0 ? void 0 : detailsPreviewData.appDetails) : Object.assign({}, detailsData === null || detailsData === void 0 ? void 0 : detailsData.appDetails)),
    loading: isPreview ? detailsPreviewLoading : detailsLoading,
    error: isPreview ? detailsPreviewError : detailsError
  };
}